import React from 'react'
import { BARS_BY_LINE, LENGTH_16TH, LINE_HEIGHT } from '../util/constants'
import { ttTo16th } from '../util/utils'

const EditorBar = (props: {
	transportTime: string
}) => {
	const {
		transportTime
	} = props
	
	return (
		<div
			style={{
				display: 'flex',
				position: 'absolute',
				left: (ttTo16th(transportTime) % ttTo16th(BARS_BY_LINE.toString())) * LENGTH_16TH,
				height: LINE_HEIGHT,
				width: ttTo16th('1') * LENGTH_16TH,
				borderRight: '2px solid #393939',
				zIndex: 3,
			}}
		/>
	)
}

export default EditorBar
